module.exports = __webpack_public_path__ + "img/staples-center_exterior2.b73b748a.jpg";